module.exports = __webpack_public_path__ + "img/horizontal_6_6_7005.c8d286c4.png";